import useSWR from "swr";

import { api } from 'api';

function usePlayerStats(playerId) {

    const fetcher = async () => {
        const response = await api.player.getPlayerStats(playerId);
        return response.data;
    }

    // Conditional key: SWR skips fetching when no playerId is provided.
    const { data, error, isLoading, mutate } = useSWR(
        playerId ? `player-stats/${playerId}` : null,
        fetcher
    );

    return {
        player: data?.player || null,
        stats: data?.stats || null,
        recentResults: data?.recentResults || null,
        playerStatsError: error,
        playerStatsLoading: isLoading,
        mutatePlayerStats: mutate,
    }
}

export default usePlayerStats;
